module.exports = __webpack_public_path__ + "media/images/front/pc/cancer-portal/banner-9b84fbab0556885b14107b5d001996f7.png";